export const RESOURCES_USER = [
  "games",
  "vouchers",
  "entities",
  "cities",
  "locations",
] as const;
export type ResourceUserType = (typeof RESOURCES_USER)[number];

export const SIDEBAR_WIDTH = 260;
export const COLLAPSED_WIDTH = 0;
export const APP_BAR_HEIGHT = 85;
